import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface NotePMSStatusAlertProps {
  isNoteReadOnly: boolean | '' | null | undefined;
  isNoteSavedToPMS: boolean | null | undefined;
  isNoteBeingSavedToPMS: boolean | '' | null | undefined;
}
export const NotePMSStatusAlert = ({
  isNoteReadOnly,
  isNoteSavedToPMS,
  isNoteBeingSavedToPMS,
}: NotePMSStatusAlertProps) => {
  return (
    <>
      {isNoteReadOnly && (
        <div
          className={`vai-flex vai-items-center vai-text-sm vai-font-semibold ${
            isNoteSavedToPMS ? 'vai-text-green-700' : 'vai-text-black'
          }`}
        >
          <FontAwesomeIcon
            icon={isNoteSavedToPMS ? faCheck : faSpinner}
            className={`vai-mr-2 ${
              isNoteBeingSavedToPMS ? 'vai-animate-spin' : ''
            }`}
          />
          <p>
            {isNoteSavedToPMS
              ? 'This note has been saved to your PMS and is now read-only.'
              : 'This note is being saved to your PMS and is now read-only.'}
          </p>
        </div>
      )}
    </>
  );
};
